<template>
    <div class="grey lighten-4 full-hc">
        <template
            v-if="statusEvaluation === 'COMPLETADA'"
            class="roma-page-content fill-height grey lighten-4"
        >
            <template v-if="!wait">
                <!-- Star web -->
                <v-row class="hidden-sm-and-down">
                    <div
                        class="secondary-appbar cardTitle white--text d-flex align-center"
                    >
                        <!-- subheader -->
                        <v-container>
                            <v-row
                                no-gutters=""
                                justify="space-between"
                                align="center"
                            >
                                <v-col cols="auto">
                                    <p class="romaBlueTwo--text d-inline mr-10">
                                        [id: {{ evaluationId }}]
                                    </p>
                                    <p class="text-uppercase d-inline">
                                        {{ code }} - {{ name }}
                                    </p>
                                </v-col>
                            </v-row>
                        </v-container>
                    </div>
                    <v-container class="pa-0 full-hc" fluid>
                        <v-row no-gutters>
                            <!-- Pdf Reader wrapper -->
                            <RomaPdfBtnZoom v-if="getLoadedPdf && !getIsPreBasicAndLinkEmbebed" class="mt-10" />
                            <v-col
                                class="pdf-wrapper pa-2 col-sm-12 col-md-7 col-lg-8 col-xl-9 mt-18"
                                ref="ref-pdf-wrapper"
                            >
                                <RomaPDF
                                    v-if="!getIsPreBasicAndLinkEmbebed"
                                    :pdfDoc="
                                        `${baseUrl}/${idMedicion}/${idForm}`
                                    "
                                />
                                
                                <div 
                                    v-if="getIsPreBasicAndLinkEmbebed"
                                    style="width: 100%;">
                                    <div 
                                        style="position: relative; padding-bottom: 56.25%; padding-top: 0; height: 0;">
                                    <iframe 
                                        frameborder="0" 
                                        width="1200px" 
                                        height="675px" 
                                        style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"  
                                        :src="getLinkEmbebed"  
                                        type="text/html" 
                                        allowscriptaccess="always" 
                                        allowfullscreen="true" 
                                        scrolling="yes" 
                                        allownetworking="all">
                                    </iframe> 
                                    </div>
                                </div>

                            </v-col>
                            <!-- Evaluation wrapper -->
                            <v-col
                                class="evaluation-wrapper col-md-5 col-lg-4 col-xl-3 pa-0"
                                style="background: #ffffff !important"
                            >
                                <v-col class="evaluation-component mt-16 pa-0">
                                    <v-col class="full-hc pa-0">
                                        <template v-if="getLoadedPdf || getIsPreBasicAndLinkEmbebed">
                                            <EvaluationResults />
                                        </template>
                                        <template v-else>
                                            <v-row
                                                class="justify-center align-center loading-component"
                                            >
                                                <v-col cols="auto">
                                                    <RomaWait
                                                        message="Cargando información"
                                                    />
                                                </v-col>
                                            </v-row>
                                        </template>
                                    </v-col>
                                </v-col>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-row>
                <!-- End Web -->
                <v-row class="hidden-md-and-up">
                    <RomaPDF v-if="!getIsPreBasicAndLinkEmbebed"
                    :pdfDoc="`${baseUrl}/${idMedicion}/${formID}`" />
                    
                    <div 
                        v-if="getIsPreBasicAndLinkEmbebed"
                        style="width: 100%;margin-top:40px;">
                        <div 
                            style="position: relative; padding-bottom: 56.25%; padding-top: 0; height: 0;">
                        <iframe 
                            frameborder="0" 
                            width="1200px" 
                            height="675px" 
                            style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"  
                            :src="getLinkEmbebed"  
                            type="text/html" 
                            allowscriptaccess="always" 
                            allowfullscreen="true" 
                            scrolling="yes" 
                            allownetworking="all">
                        </iframe> 
                        </div>
                    </div>
                    <template v-if="getLoadedPdf || getIsPreBasicAndLinkEmbebed">
                        <RomaEvaluationMobileResults />
                    </template>
                </v-row>
            </template>
            <template v-else>
                <v-row class="justify-center align-center loading-component">
                    <v-col cols="auto">
                        <RomaWait message="Cargando información" />
                    </v-col>
                </v-row>
            </template>
        </template>
        <template v-else class="fill-height grey">
            <div v-if="statusEvaluation !== null">
                <RomaMessages
                    message="<h1>Ya has respondido la evaluación</h1>"
                    :isIcon="true"
                />
            </div>
        </template>
    </div>
</template>

<script>
import RomaPDF from "@/components/commons/RomaPDF.vue";
import EvaluationResults from "@/components/evaluation/EvaluationResults.vue";
import RomaPdfBtnZoom from "@/components/commons/RomaPdfBtnZoom.vue";
import RomaMessages from "@/components/commons/RomaMessages.vue";
import RomaWait from "@/components/commons/RomaWait.vue";
import RomaEvaluationMobileResults from "@/components/mobile/RomaEvaluationMobileResults.vue";
import { mapActions, mapGetters } from "vuex";

export default {
    name: "evaluation-results",
    data() {
        return {
            statusEvaluation: "COMPLETADA",
            baseUrl: process.env.VUE_APP_ROMA_PDF,
            window: {
                width: 0,
                height: 0
            },
            wait: true,
            evaluationId: null,
            code: null,
            name: null,
            idForm: null,
            load: true
        };
    },
    components: {
        RomaPDF,
        EvaluationResults,
        RomaPdfBtnZoom,
        RomaWait,
        RomaMessages,
        RomaEvaluationMobileResults
    },
    computed: {
        ...mapGetters({
            getLoadedPdf: "getLoadedPdf",
            getUserData: "getUserData",
            getMa: "getMa",
            getEvaluation: "getEvaluation",
            getEvaluationDetail: "getEvaluationDetail",
            getLinkEmbebed: "getLinkEmbebed",
            getIsPreBasicAndLinkEmbebed: "getIsPreBasicAndLinkEmbebed",
            getCurrentTextAnswers:"getCurrentTextAnswers",
            getCurrentFilesAnswers:"getCurrentFilesAnswers",
            getCurrentAnswers:"getCurrentAnswers",
        }),
        formID() {
            return this.getEvaluationDetail.form.idForma;
        },
        idMedicion() {
            return this.getEvaluationDetail.medicionAsignadaTO.medicionTO
                .idMedicion;
        }
    },
    mounted() {
        this.loadResults();
        this.setEnablePdfPoll(true);
        this.name = this.getEvaluationDetail.medicionAsignadaTO.medicionTO.name;
        this.code = this.getEvaluationDetail.medicionAsignadaTO.medicionTO.code;
        this.evaluationId = this.getMa;
        this.idForm = this.getEvaluationDetail.form.idForma;
    },
    methods: {
        ...mapActions({
            setResults: "setResults",
            setEnablePdfPoll: "setEnablePdfPoll",
            fetchCurrentAnswers: "fetchCurrentAnswers",
            setCurrentAnswers: "setCurrentAnswers"
        }),
        async loadResults() {
            await this.setResults({
                i: this.getUserData.institutionContext.institutionId,
                pi: this.getUserData.personId,
                pdi: this.getUserData.institutionContext.periodId,
                ma: this.getMa
            })
                .then(() => {
                    this.wait = false;
                })
                .catch(e => {
                    console.info(e);
                    this.wait = false;
                });

            const {
                idMatricula,
                idMedicionAsignada,
                idSeccion
            } = this.getEvaluationDetail;
            const idForma = this.getEvaluationDetail.form.idForma
            const object = {
                idMedicionAsignada,
                idMatricula,
                idSeccion,
                idForma
            };

            await this.fetchCurrentAnswers(object);
            this.updateAnswersIfRubrica();

        },
        updateAnswersIfRubrica(){
            const listAnswers = this.getCurrentAnswers;
            const listAnswersDesarrollo = this.getCurrentTextAnswers;
            const listAnswersArchivo = this.getCurrentFilesAnswers;

            for (let i = 0; i < listAnswers.length; i++) {
                if (listAnswersDesarrollo && listAnswersDesarrollo.length > 0) {
                    for (let j = 0; j < listAnswersDesarrollo.length; j++) {
                        if(listAnswers[i].nroPregunta === listAnswersDesarrollo[j][3]) {
                            listAnswers[i]["textoRespuesta"] = listAnswersDesarrollo[j][4];
                        }
                    }
                }else{
                    listAnswers[i]["textoRespuesta"] = "";
                }
                

                if (listAnswersArchivo && listAnswersArchivo.length > 0) {
                    listAnswers[i]["fileRespuesta"] = [];
                    for (let k = 0; k < listAnswersArchivo.length; k++) {
                        if(listAnswers[i].nroPregunta === listAnswersArchivo[k][4]) {
                            const f = new File([""], listAnswersArchivo[k][5], { type: 'text/html' });
                            listAnswers[i]["fileRespuesta"].push(f);
                        }
                    }
                }
            }
            this.setCurrentAnswers(listAnswers);
        },
    }
};
</script>

<style lang="scss">
$secondary-appbar-w: 55.5px;
.group-btn-zoom {
    right: 32% !important;
    top: 120px;
}

.full-hc {
    min-height: calc(100vh - 112px);
}
.cardTitle {
    position: fixed;
    width: 102%;
    z-index: 9;
}
.roma-page-content {
    position: relative;

    .secondary-appbar {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: $secondary-appbar-w;
    }

    .evaluation-content {
        // margin-top: $secondary-appbar-w;
        height: 100% !important;
    }
    .evaluation-wrapper {
        background: #ffffff !important;
        min-height: calc(100vh - 112px) !important;
    }
    .pdf-wrapper {
        min-height: calc(100vh - 120px);
    }
    .evaluation-component {
        height: 100% !important;
    }
    // no paddings evaluation detail view
    &.EvaluationDetail,
    &.EvaluationResults {
        padding: $secondary-appbar-w 0 0 0;
        & > .container {
            max-width: 100% !important;
        }
    }
}

.mt-18 {
    margin-top: 75px !important;
}
@media (max-width: 800px) {
    .toasted-container {
        top: 55px !important;
    }
}
</style>
